import { c as _c } from "react/compiler-runtime";
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
export interface SidebarStepItemProps {
  isActive: boolean;
  label: string;
  number: string;
  to: string;
  /** Counter or chevron shown at the end of the row. */
  trailing?: React.ReactNode;
}

/** One of the numbered steps of the workflow: 01 Measure, 02 Analyze… */
export const SidebarStepItem = t0 => {
  const $ = _c(13);
  const {
    isActive,
    label,
    number,
    to,
    trailing
  } = t0;
  const t1 = isActive && "bg-accent shadow-[inset_0_0_0_1px_var(--input)]";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex min-h-10 items-center gap-2.5 rounded-md px-2.5 text-[14.5px] font-medium text-foreground transition-colors short:min-h-8", "hover:bg-accent", "focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isActive && "text-[color-mix(in_oklab,var(--ptl-brass)_88%,var(--foreground))]";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("w-[18px] font-mono text-[11px] text-ptl-brass", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== number || $[5] !== t4) {
    t5 = <span className={t4}>{number}</span>;
    $[4] = number;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== label || $[8] !== t2 || $[9] !== t5 || $[10] !== to || $[11] !== trailing) {
    t6 = <NavLink to={to} className={t2}>{t5}{label}{trailing}</NavLink>;
    $[7] = label;
    $[8] = t2;
    $[9] = t5;
    $[10] = to;
    $[11] = trailing;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};